import { MapPin, ShieldCheck, Clock } from "lucide-react";

/**
 * Author byline card shown at the top of every blog article.
 *
 * Presents a "written by the Clocktower Cars local team" attribution with a
 * circular team photo, published date and read time. Reinforces Google's
 * E-E-A-T signal (Experience, Expertise, Authoritativeness, Trust) by pairing
 * every piece of content with a real local operator identity.
 */
const AUTHOR = {
  name: "The Clocktower Cars local team",
  role: "Licensed private-hire operator · Crawley RH10",
  image: "/images/services/chauffeur.jpg",
  bio:
    "Based at Churchill Court in Crawley, our team has been moving Surrey and Sussex " +
    "travellers to and from Gatwick, Heathrow and London since 1996. Every guide on this " +
    "blog is checked by our drivers and dispatch team so it reflects how airport journeys " +
    "in the area really work.",
};

const fmtDate = (d) => new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });

export const AuthorByline = ({ date, readTime }) => (
  <section data-testid="article-author-byline" className="mt-8 sm:mt-10 bg-surface border border-[#EAEBEA] rounded-2xl p-5 sm:p-6 flex items-start gap-4 not-prose">
    <div className="relative h-14 w-14 sm:h-16 sm:w-16 shrink-0 rounded-full overflow-hidden ring-2 ring-white shadow-[0_8px_20px_-8px_rgba(0,0,0,0.25)]">
      <img
        src={AUTHOR.image}
        alt={AUTHOR.name}
        className="h-full w-full object-cover"
        loading="lazy"
      />
      <span className="absolute -bottom-0.5 -right-0.5 grid place-items-center h-5 w-5 rounded-full bg-brand text-white ring-2 ring-surface">
        <ShieldCheck className="h-3 w-3" strokeWidth={2.5} />
      </span>
    </div>
    <div className="min-w-0 flex-1">
      <p className="text-[11px] font-bold uppercase tracking-[0.15em] text-brand mb-0.5">Written by</p>
      <p className="font-heading text-sm sm:text-base font-bold text-ink" data-testid="byline-author-name">{AUTHOR.name}</p>
      <p className="text-xs text-ink/60 mt-0.5 flex flex-wrap items-center gap-x-3 gap-y-1">
        <span className="inline-flex items-center gap-1"><MapPin className="h-3 w-3 text-brand" strokeWidth={2.25} /> {AUTHOR.role}</span>
        {date && <span className="inline-flex items-center gap-1"><Clock className="h-3 w-3" strokeWidth={2.25} /> {fmtDate(date)}</span>}
        {readTime && <span className="text-ink/40">·</span>}
        {readTime && <span>{readTime}</span>}
      </p>
      <p className="mt-2.5 text-xs sm:text-sm text-ink/60 leading-relaxed">{AUTHOR.bio}</p>
    </div>
  </section>
);
